// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federvorspannung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federvorspannungDE: PageEntry = {
  id: "post.federvorspannung",
  locale: "de",
  slug: "federvorspannung",
  seo: {
    title: "Glossar: Federvorspannung einfach erklärt | Dietz GmbH",
    description: "Die Federvorspannung bezieht sich auf die anfängliche Dehnung oder Kompression einer Feder vor der Anwendung einer äußeren Last. Durch die Vorspannung wird die Feder bereits teilwe",
  },
  type: "post",
  h1: "Glossar: Federvorspannung einfach erklärt",
  intro: "Die Federvorspannung bezieht sich auf die anfängliche Dehnung oder Kompression einer Feder vor der Anwendung einer äußeren Last. Durch die Vorspannung wird die Feder bereits teilweise verformt, bevor sie auf Belastungen reagiert. Die Federvorspannung wird oft in Anwendungen verwendet, bei denen eine sofortige Reaktion der Feder erforderlich ist oder wenn die Belastung kontrolliert werden muss. Die genaue Festlegung der Federvorspannung ist entscheidend für die Funktionalität und Leistung von Feder-Systemen, insbesondere in Bereichen wie Fahrzeugfahrwerken oder industriellen Maschinen.",
  blocks: [

  ],
};
